import { Box, Button, Theme, useTheme } from "@mui/material";
import { PickersActionBarProps } from "@mui/x-date-pickers";

const useStyles = (theme: Theme) => ({
  actionBar: {
    gridRow: 3,
    gridColumnStart: 1,
    gridColumnEnd: 4,
    marginLeft: "auto",
    p: theme.spacing(1),
  },
});

const CustomActionBar = (
  props: PickersActionBarProps & { onCustomClear?: () => void }
) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const { onCancel, onAccept, onCustomClear, actions } = props;

  return (
    <Box sx={styles.actionBar}>
      {actions?.includes("clear") && (
        <Button onClick={onCustomClear}>Clear</Button>
      )}
      {actions?.includes("cancel") && (
        <Button onClick={onCancel}>Cancel</Button>
      )}
      {actions?.includes("accept") && <Button onClick={onAccept}>OK</Button>}
    </Box>
  );
};

export default CustomActionBar;
